export default function roles(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT_ROLE':
            return {
                ...state,
                role: action.role,
            }
        default:
            return state;
    }
}
